// extracted by mini-css-extract-plugin
module.exports = {"popover":"Popover_popover__2FmGk"};